import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from './home/page'
import AddPage from './add/page'
import EditPage from './edit/page'
import AddKassaPage from './add-kassa/page'
import EditKassaPage from './edit-kassa/page'

const ForeignCurrency = () => {
  return (
    <Routes>
        <Route path="*" element={<HomePage />}/>

        <Route path="add" element={<AddPage />}/>
        <Route path="add-kassa" element={<AddKassaPage />}/>


        <Route path="edit/:id" element={<EditPage />}/>
        <Route path="edit-kassa/:id" element={<EditKassaPage />}/>
    </Routes>
  )
}

export default ForeignCurrency